import CustomCard from '../customs/CustomCard';
import { useSelector } from 'react-redux';

import AppDownloadsSection from '../components/info/AppDownloadsSection';
import AirlineManagementSection from '../components/info/AirlineManagementSection';
import AirportManagementSection from '../components/info/AirportManagementSection';
import ActiveAirlinesSection from '../components/info/ActiveAirlinesSection';


const InfoPage = () => {
  const { userData } = useSelector((state) => state.auth);
  const canEdit = userData?.role === 'admin';

  return (
    <CustomCard style={{ margin: 20 }}>
      <AppDownloadsSection canEdit={canEdit} />
      <AirportManagementSection canEdit={canEdit} />
      <AirlineManagementSection canEdit={canEdit} />
      <ActiveAirlinesSection />
    </CustomCard>
  );
};


export default InfoPage;
